import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import DropDownSingle from '../../../../Components/DropDownSingle';
import DropDownMultiple from '../../../../Components/DropDownMultiple';
import SwitchInput from '../../../../Components/SwitchInput';
import ArrayInputConfig from '../../../../Components/ArrayInputConfig';
import ConfirmBeforeTypeSwitchModal from '../ConfirmBeforeTypeSwitchModal';
import {
	SERVICE_CONFIG_KEYS,
	SERVICE_KEYS_CONDITIONS,
	ALL_SERVICES,
	DIMENSIONS_LIST,
	COLUMNS_LIST,
	DIMENSIONAL_COMBINATION_LISTS
} from '../../constants';
import { Box } from '@mui/system';
import { Modalv2Context } from '../../../../Contexts/Modalv2Context';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import useCommonStyles from '../../../../commonStyles';
import { checkMandatoryServiceKey } from '../../helpers';
const {
	CONFIGS,
	ENABLED,
	SERVICE_TYPE,
	AD_UNITS,
	DIMENSIONS,
	COLUMNS,
	DIMENSIONAL_COMBINATIONS,
	TIME_PERIOD_IN_DAYS,
	CPM_MULTIPLIER,
	MULTIPLIER_DIFFERENCE,
	DEFAULT_MIN_MULTIPLIER,
	STARTING_MULTIPLIER,
	DATE_OFFSET,
	ONLY_TOP_COUNTRIES,
	SD_MULTIPLIER,
	SKIP_ECPM,
	SKIP_FILL_RATE,
	SKIP_REQUEST_ECPM,
	PROFITABLE_COMBINATIONS_ONLY,
	NTH_STANDARD_DEVIATION,
	THRESHOLD
} = SERVICE_CONFIG_KEYS;

const ServiceConfigCard = ({ serviceConfig, deleteServiceConfig, index }) => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);
	const { updateModalContent } = useContext(Modalv2Context);
	const commonStyleClasses = useCommonStyles();

	const removeKeysAndUpdateServiceConfig = (serviceType) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const clonedServiceConfig = clonedBannerFpConfig[CONFIGS][index];
		const serviceKeyConditionArray = Object.keys(SERVICE_KEYS_CONDITIONS);
		serviceKeyConditionArray.forEach((key) => {
			const serviceTypesAllowed = SERVICE_KEYS_CONDITIONS[key];
			if (!serviceTypesAllowed.includes(serviceType)) {
				delete clonedServiceConfig[key];
			}
		});
		updateServiceConfig(SERVICE_TYPE, serviceType, clonedBannerFpConfig);
	};

	const updateServiceConfig = (key, updatedValue, obj) => {
		const clonedBannerFpConfig = obj || structuredClone(bannerFpConfig);
		const clonedServiceConfig = clonedBannerFpConfig[CONFIGS][index];
		clonedServiceConfig[key] = updatedValue;
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	const switchServiceType = (newServiceType) => {
		updateModalContent(
			<ConfirmBeforeTypeSwitchModal
				cbOnApproval={() => {
					removeKeysAndUpdateServiceConfig(newServiceType);
					updateModalContent(null);
				}}
				noteContent="Note**: Switching between Service types will cause parameters to be deleted that are not
                required in the new service type. Are you sure you want to switch ?
"
			/>
		);
	};

	return (
		<Grid item xs={12} className={commonStyleClasses.basicOutlinedBox}>
			<Grid container spacing={1}>
				<Grid item xs={2}>
					<SwitchInput
						isObjectEditor={false}
						directValue={serviceConfig[ENABLED]}
						updateDirectValue={(newVal) => updateServiceConfig(ENABLED, newVal)}
						label="Enabled"
						containerStyles={{ marginTop: '5rem' }}
						isMandatory={true}
					/>
				</Grid>
				<Grid item xs={3}>
					<DropDownSingle
						isObjectEditor={false}
						directValue={serviceConfig[SERVICE_TYPE]}
						updateDirectValue={switchServiceType}
						list={ALL_SERVICES}
						label="Service Type"
						isMandatory={true}
					/>
				</Grid>
				{SERVICE_KEYS_CONDITIONS[SD_MULTIPLIER].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<DropDownSingle
							isObjectEditor={false}
							directValue={serviceConfig[SD_MULTIPLIER]}
							updateDirectValue={(newVal) => updateServiceConfig(SD_MULTIPLIER, newVal)}
							list={[
								{ value: 1, label: '1' },
								{ value: 2, label: '2' }
							]}
							label="Sd Multiplier"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], SD_MULTIPLIER)}
						/>
					</Grid>
				)}

				{SERVICE_KEYS_CONDITIONS[ONLY_TOP_COUNTRIES].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<SwitchInput
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								ONLY_TOP_COUNTRIES
							)}
							containerStyles={{ marginTop: '5rem' }}
							isObjectEditor={false}
							directValue={serviceConfig[ONLY_TOP_COUNTRIES]}
							updateDirectValue={(newVal) => updateServiceConfig(ONLY_TOP_COUNTRIES, newVal)}
							label="Only Top Countries"
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[SKIP_ECPM].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={2}>
						<SwitchInput
							containerStyles={{ marginTop: '5rem' }}
							isObjectEditor={false}
							directValue={serviceConfig[SKIP_ECPM]}
							updateDirectValue={(newVal) => updateServiceConfig(SKIP_ECPM, newVal)}
							label="Skip ECPM"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], SKIP_ECPM)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[SKIP_FILL_RATE].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={2}>
						<SwitchInput
							containerStyles={{ marginTop: '5rem' }}
							isObjectEditor={false}
							directValue={serviceConfig[SKIP_FILL_RATE]}
							updateDirectValue={(newVal) => updateServiceConfig(SKIP_FILL_RATE, newVal)}
							label="Skip FillRate"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], SKIP_FILL_RATE)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[SKIP_REQUEST_ECPM].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<SwitchInput
							containerStyles={{ marginTop: '5rem' }}
							isObjectEditor={false}
							directValue={serviceConfig[SKIP_REQUEST_ECPM]}
							updateDirectValue={(newVal) => updateServiceConfig(SKIP_REQUEST_ECPM, newVal)}
							label="Skip RequestECPM"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], SKIP_REQUEST_ECPM)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[PROFITABLE_COMBINATIONS_ONLY].includes(
					serviceConfig[SERVICE_TYPE]
				) && (
					<Grid item xs={3}>
						<SwitchInput
							containerStyles={{ marginTop: '5rem' }}
							isObjectEditor={false}
							directValue={serviceConfig[PROFITABLE_COMBINATIONS_ONLY]}
							updateDirectValue={(newVal) =>
								updateServiceConfig(PROFITABLE_COMBINATIONS_ONLY, newVal)
							}
							label="Profitable Combinations"
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								PROFITABLE_COMBINATIONS_ONLY
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[NTH_STANDARD_DEVIATION].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[NTH_STANDARD_DEVIATION]}
							updateDirectValue={(newVal) => updateServiceConfig(NTH_STANDARD_DEVIATION, newVal)}
							inputType="number"
							label="Nth SDV"
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								NTH_STANDARD_DEVIATION
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[THRESHOLD].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[THRESHOLD]}
							updateDirectValue={(newVal) => updateServiceConfig(THRESHOLD, newVal)}
							inputType="number"
							label="Threshold"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], THRESHOLD)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[TIME_PERIOD_IN_DAYS].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[TIME_PERIOD_IN_DAYS]}
							updateDirectValue={(newVal) => updateServiceConfig(TIME_PERIOD_IN_DAYS, newVal)}
							inputType="number"
							label="TimePeriod"
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								TIME_PERIOD_IN_DAYS
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[CPM_MULTIPLIER].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[CPM_MULTIPLIER]}
							updateDirectValue={(newVal) => updateServiceConfig(CPM_MULTIPLIER, newVal)}
							inputType="number"
							label="Cpm Multiplier"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], CPM_MULTIPLIER)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[MULTIPLIER_DIFFERENCE].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[MULTIPLIER_DIFFERENCE]}
							updateDirectValue={(newVal) => updateServiceConfig(MULTIPLIER_DIFFERENCE, newVal)}
							inputType="number"
							label="Multiplier Diff"
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								MULTIPLIER_DIFFERENCE
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[DATE_OFFSET].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[DATE_OFFSET]}
							updateDirectValue={(newVal) => updateServiceConfig(DATE_OFFSET, newVal)}
							inputType="number"
							label="Date Offset"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], DATE_OFFSET)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[DEFAULT_MIN_MULTIPLIER].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[DEFAULT_MIN_MULTIPLIER]}
							updateDirectValue={(newVal) => updateServiceConfig(DEFAULT_MIN_MULTIPLIER, newVal)}
							inputType="number"
							label="Default MinMultiplier"
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								DEFAULT_MIN_MULTIPLIER
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[STARTING_MULTIPLIER].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<InputConfig
							isObjectEditor={false}
							directValue={serviceConfig[STARTING_MULTIPLIER]}
							updateDirectValue={(newVal) => updateServiceConfig(STARTING_MULTIPLIER, newVal)}
							inputType="number"
							label="Starting Multiplier"
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								STARTING_MULTIPLIER
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[DIMENSIONS].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<DropDownMultiple
							isObjectEditor={false}
							directValue={serviceConfig[DIMENSIONS]}
							updateDirectValue={(newVal) => updateServiceConfig(DIMENSIONS, newVal)}
							list={DIMENSIONS_LIST}
							label="Dimensions"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], DIMENSIONS)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[COLUMNS].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={3}>
						<DropDownMultiple
							isObjectEditor={false}
							directValue={serviceConfig[COLUMNS]}
							updateDirectValue={(newVal) => updateServiceConfig(COLUMNS, newVal)}
							list={COLUMNS_LIST}
							label="Columns"
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], COLUMNS)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[DIMENSIONAL_COMBINATIONS].includes(
					serviceConfig[SERVICE_TYPE]
				) && (
					<Grid item xs={12}>
						<DropDownMultiple
							isObjectEditor={false}
							directValue={serviceConfig[DIMENSIONAL_COMBINATIONS]}
							updateDirectValue={(newVal) => updateServiceConfig(DIMENSIONAL_COMBINATIONS, newVal)}
							list={DIMENSIONAL_COMBINATION_LISTS}
							label="Dimensional Combinations"
							selectBlockStyles={{ width: '100%' }}
							isMandatory={checkMandatoryServiceKey(
								serviceConfig[SERVICE_TYPE],
								DIMENSIONAL_COMBINATIONS
							)}
						/>
					</Grid>
				)}
				{SERVICE_KEYS_CONDITIONS[AD_UNITS].includes(serviceConfig[SERVICE_TYPE]) && (
					<Grid item xs={12}>
						<ArrayInputConfig
							isObjectEditor={false}
							directValue={serviceConfig[AD_UNITS] || []}
							updateDirectValue={(newVal) => updateServiceConfig(AD_UNITS, newVal)}
							label="Ad Units"
							inputContainerStyle={{
								display: 'flex',
								flexWrap: 'wrap',
								width: '100%'
							}}
							inputGridStyle={{ display: 'flex' }}
							isMandatory={checkMandatoryServiceKey(serviceConfig[SERVICE_TYPE], AD_UNITS)}
						/>
					</Grid>
				)}
				<Grid item xs={12} style={{ marginTop: '2rem' }}>
					<DeleteOutlinedIcon
						color="primary"
						onClick={() => deleteServiceConfig(index)}
						className={commonStyleClasses.icon}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ServiceConfigCard;
